import { render, staticRenderFns } from "./Throughrate-details.vue?vue&type=template&id=139c1814&scoped=true&"
import script from "./Throughrate-details.vue?vue&type=script&lang=js&"
export * from "./Throughrate-details.vue?vue&type=script&lang=js&"
import style0 from "./Throughrate-details.vue?vue&type=style&index=0&id=139c1814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c1814",
  null
  
)

export default component.exports